<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline mr-4">
            <v-icon class="pl-2">email</v-icon>
            Set users emails list
          </span>
          <v-btn absolute left depressed flat fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="emails_list" data-vv-scope="emails_list" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12>
                <v-textarea
                  v-model="emails"
                  rows="25"
                  label="Emails list"
                  hint="Enter emails one per line or separated by commas"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="setEmails()" :loading="loading" :disabled="loading">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'UpdateMailsListModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['updateMailListDialog'],
  data () {
    return {
      dialog: this.updateMailListDialog,
      emails: '',
      loading: false,
      dictionary: {
        en: {
          custom: {
            'emails_list.email': {
              required: 'Please type email',
              email: 'E-mail not valid'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  watch: {
    updateMailListDialog: {
      handler () {
        this.dialog = this.updateMailListDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('updateMailListDialog', this.dialog)
      }
    }
  },
  methods: {
    setEmails () {
      this.$validator.validateAll('emails_list').then(res => {
        if (res) {
          let arrEmails = this.strToArray(this.emails)
          if (this.checkValidEmails(arrEmails)) {
            this.loading = true
            this.$store.dispatch('UPDATE_MAILS_LIST', arrEmails).then(res => {
              this.$toasted.show(`Emails list was succesfully updated: added ${res.added}, removed ${res.removed}, same ${res.same}, not found ${res.not_found}`, {duration: 10000})
              this.$parent.$emit('updateUsersList')
              this.loading = false
              this.closeModal()
            }, err => {
              console.log('UPDATE_MAILS_LIST error', err)
              this.loading = false
              let errorText = this.$services.getApiError(err)
              if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
            })
          }
        }
      })
    },
    checkValidEmails (arrEmails) {
      let arrBadEmail = arrEmails.filter(email => {
        return !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email) // eslint-disable-line
      })
      if (arrBadEmail.length) {
        this.$eventEmitter.$emit('showAlert', 'warning', 'You have some bad emails in the list', `<p>Bad emails:</p><p>${arrBadEmail.join('<br />')}</p>`)
      }
      return !arrBadEmail.length || false
    },
    strToArray (strEmails) {
      let arrEmails = []

      // check if there are some lines
      var match = /\r|\n/.exec(strEmails)

      if (match) {
        let arrLines = strEmails.match(/[^\r\n]+/g)
        arrEmails = arrLines.map((line) => {
          return line.split(',').map((keyword) => { return keyword.trim() })
        })
        // join arrays in array
        arrEmails = [].concat.apply([], arrEmails)
      } else {
        arrEmails = strEmails.split(',').map((keyword) => { return keyword.trim() })
      }

      // remove empty values
      arrEmails = arrEmails.filter((keyword) => {
        return keyword != null && keyword !== ''
      })

      // convert to format with period
      // arrEmails = arrEmails.map((keyword) => { return [keyword, 1] })

      return arrEmails
    },
    closeModal () {
      this.dialog = false
      this.email = ''
      // setTimeout(() => {
      //   this.$validator.errors.clear('invite_user')
      // }, 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/UpdateMailsListModal.vue